// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pb_a bha_cw bha_jx bha_jo bha_a bha_j bha_ri bha_rj","SearchPanel__icon":"pb_b bha_ui bha_hb bha_ro bha_tu","SearchPanel__input":"pb_c bha_iv bha_cx bha_z"};